<template>
  <div class="panel">
    <slot name="header">
      <h2 class="ml-10">Self Awareness</h2>
    </slot>
    <div class="panel-body">
      <div class="chart-wrapper">
        <div class="chart-item mt-20">
          <chart :score="score" :is-print="isPrint" />
        </div>
        <div class="chart-text lead">
          <span v-html="message"></span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import chart from './chartSelfAwareness.vue';
  export default {
    name: 'SelfAwareness',
    components: { chart },
    props: {
      score: {
        required: true,
      },
      message: {
        required: true,
      },
      isPrint: {
        type: Boolean,
        required: false,
        default: false,
      },
    },
  };
</script>

<style lang="scss" scoped>
  .chart-wrapper {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
  }

  .chart-item {
    flex: 1 1 10%;
  }
  .chart-text {
    flex: 1 1 35%;
    padding: 1.5rem;
    border-left: 0.1rem solid #ddd;
  }

  .panel-body {
    padding: 0 15px;
  }

  .col-md-6 {
    padding: 15px 15px;
    &:first-of-type {
      border-right: 1px solid #e3e3e3;
    }
  }

  .border-left {
    border-left: 1px solid #e3e3e3;
  }
</style>
